import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import { isDevelopment } from 'env-utils';
import { AppPages } from '../../../common/routing/app-navigator';
import Summary from '../../../elements/Summary/Summary';
import { toggleFiltersPanel } from '../../active-issues/store-actions/issue-store-actions';
import IssuesStore from '../../active-issues/stores/issues-store';

const IssuesSummaryContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const { totalIssues, totalFilteredIssues, totalResolvedIssues } =
    useSnapshot(IssuesStore);

  return (
    <Summary
      headerText='Active Issues'
      linkText={
        isDevelopment()
          ? totalResolvedIssues && totalResolvedIssues !== 0
            ? `Show Resolved Issues\n (${totalResolvedIssues.toLocaleString()})`
            : 'Show Resolved Issues'
          : undefined
      }
      linkUrl={isDevelopment() ? AppPages.ResolvedIssues : undefined}
      navComponent={NavLink}
      count={totalFilteredIssues}
      total={totalIssues}
      onCollapse={toggleFiltersPanel}
    />
  );
};

export default IssuesSummaryContainer;
